import { ensureArray } from "shared/lib/arrayUtils"

export function serializeQueryStringArray(
  array: string[] | null | undefined
): string {
  return ensureArray(array).join(",") || ""
}
